import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', function (value, format = 'DD MMMM YYYY h:mm A') {
  if (!value) {
    return "";
  }
  return moment(value).format(format);
});
